module.exports = __webpack_public_path__ + "static/media/bet-white-3.b1e110b1.png";